import { Counter } from "@/components/flexkit/badge/Counter";
import { ActionGroupType } from "@/utils/automation-execution-action";
import type { FC } from "react";

type WorkflowExecutionActionGroupLabelProps = {
    groupType: ActionGroupType;
    count: number;
};

export const WorkflowExecutionActionGroupLabel: FC<WorkflowExecutionActionGroupLabelProps> = ({ groupType, count }) => {
    return (
        <span className="flex items-center gap-1.5 text-sm font-medium text-content-primary">
            {getGroupLabel(groupType)}
            <Counter counter={`${count}`} variant="default" />
        </span>
    );
};

const getGroupLabel = (groupType: ActionGroupType): string => {
    switch (groupType) {
        case ActionGroupType.Active:
            return "Active";
        case ActionGroupType.Pending:
            return "Pending";
        case ActionGroupType.Completed:
            return "Completed";
        case ActionGroupType.Failed:
            return "Failed";
        case ActionGroupType.Stopped:
            return "Stopped";
        case ActionGroupType.Deleted:
            return "Deleted";
        default:
            return "Unknown";
    }
};
